let language = {
    "A112B1500013": "The postal code you entered does not match the selected country or region",
    "A112B1500014": "Connection to the server timed out, please try again ",
    "A112B712316":"The shipping address issue, please update your address to ensure your order arrives correctly."

};

export { language }